import { VetRxCategory } from '@app/cart/types/vet-rx';
import type { IconNames } from '@petsmart-ui/sparky';
import type { ItemUI, Item, CartUI } from '@libs/common-node';
import { isProductRxMedColdItem, isProductRxFoodItem, isProductRxMedItem } from '@app/cart/utils/productVetRxColdItem';
import type { Nullable } from '@commercetools/ts-client';

export const getVetRxData = (category: VetRxCategory): { text: string; icon: IconNames } => {
    switch (category) {
        case VetRxCategory.COLD:
            return { text: 'Cold item', icon: 'circle-snowflake' };
        case VetRxCategory.RX:
            return { text: 'Prescription item', icon: 'circle-rx' };
        case VetRxCategory.VET:
            return { text: 'Vet diet item', icon: 'circle-plus' };
        default:
            return { text: '', icon: 'none' };
    }
};

export const getDrawerHeader = (category: VetRxCategory | null): string => {
    switch (category) {
        case VetRxCategory.COLD:
            return 'Cold item info';
        case VetRxCategory.RX:
            return 'Prescription info required';
        case VetRxCategory.VET:
            return 'Vet authorization required';
        default:
            return '';
    }
};

export const vetRxItemRequiresAuthorization = (item: ItemUI | Item) =>
    isProductRxMedItem(item) || isProductRxFoodItem(item) || isProductRxMedColdItem(item);

export const vetRxItemsRequireAuthorization = (items: Array<ItemUI | Item>) =>
    items.some(item => vetRxItemRequiresAuthorization(item));

export const cartHasVetRxItem = (cart: Nullable<CartUI>) =>
    cart?.fulfillmentGroups.some(group => group.items?.some(item => isProductRxMedItem(item)));

export const cartHasVetDietItem = (cart: Nullable<CartUI>) =>
    cart?.fulfillmentGroups.some(group => group.items?.some(item => isProductRxFoodItem(item)));

export const cartHasWrxOnlyClinic = (cart: Nullable<CartUI>) =>
    cart?.fulfillmentGroups.some(group =>
        group.items?.some(item => item?.prescription?.vetClinic?.writtenRxOnly === true)
    );
